import { Col, Row } from "@commonlibs";
import { alpha } from "@commonlibs";
import styled, { css } from "styled-components";
import { ImageUploadDisplayRootProps, SingleImageUploadRootProps } from "./SingleImageUpload.types";
import { DEFAULT_SIZE_WITH_CONTROLLERS } from "./SingleImageUpload";

const imageStyles = css`
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        transition: filter 0.5s ease;
        filter: blur(0) brightness(1);
    }
    .upload-input-display.isEditable {
        &:hover {
            img {
                transition: filter 0.3s ease;
                filter: blur(2px);
            }
        }
    }
    &.is-loading {
        img {
            filter: blur(4px);
        }
    }
`;

const controlButtonStyles = css(
    ({ theme: { palette } }) => css`
        .file-upload-controls {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
        }
        .upload-button-display {
            min-width: max-content;
        }
        .file-upload-controls {
            width: max-content;
        }
        @media (max-width: 350px) {
            .file-upload-controls {
                width: unset;
            }
        }

        //Change / Upload button styles
        .upload-button-display.change.upload-button-display.upload-button-display {
            border-color: ${palette.overlays[0][60]};
            color: ${palette.overlays[0][60]};
            background-color: ${palette.overlays[0][12]};
            &:hover {
                background-color: ${palette.overlays[0][20]};
            }
        }

        //Delete button styles
        .delete-button.delete-button.delete-button {
            background-color: ${alpha(palette.status.error, 0.2)};
            &:hover {
                background-color: ${alpha(palette.status.error, 0.25)};
            }
        }
    `,
);

export const imageHoverDarkenStyles = css`
    img {
        transition: filter 0.4s ease;
    }
    &:hover,
    &:active {
        img {
            transition: filter 0.4s ease;
            filter: blur(2px) brightness(0.5);
        }
    }
`;

export const SingleImageUploadRoot = styled(Row)<SingleImageUploadRootProps>(
    ({ theme: { spacing }, size }) => css`
        row-gap: ${spacing["3"]};
        column-gap: ${spacing[!DEFAULT_SIZE_WITH_CONTROLLERS.includes(size) ? "2" : "7"]};
        align-items: center;
        flex-wrap: wrap;
        flex: 1;
    `,
);

export const ImageUploadDisplayRoot = styled(Col)<ImageUploadDisplayRootProps>(
    ({ theme: { palette }, showInternalControllers }) => css`
        position: relative;
        &.full-width {
            flex: 1;
        }
        &:hover {
            .upload-input-display.isEditable {
                background-color: ${palette.overlays[800][20]};
            }
        }

        //Image styles
        ${imageStyles}
        ${showInternalControllers && imageHoverDarkenStyles}
        //Control button styles
        ${controlButtonStyles}
    `,
);
